import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { amplitudeEventLogger } from "@collectivehealth/frontend-analytics";

// DLS
import "@collectivehealth/dls-icons/dist/elements/dls-icon-arrow-right-large";

// Styles
import styles from "./Card.css";

function Card({
  color,
  title,
  content,
  href,
  optionalClasses,
  clickEventName,
  clickEventParams = {}
}) {
  // Click handler for amplitude tracking for clicking shortcuts
  function cardClickLogger() {
    amplitudeEventLogger(clickEventName, clickEventParams);
  }

  return (
    <a
      href={`#${href}`}
      className={classNames(styles.container, styles[color], optionalClasses)}
      onClick={cardClickLogger}
      tabIndex="0"
    >
      <header className={styles.cardTitle}>
        <p className={styles.noMargin}>{title}</p>
        <dls-icon-arrow-right-large />
      </header>
      <div className={styles.cardBody}>{content}</div>
    </a>
  );
}

Card.propTypes = {
  color: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  href: PropTypes.string
};

export default Card;
